export default __webpack_public_path__ + "static/media/img-1.45e1d8dc.jpg";